import { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";

// Éclairage de la scène 3D avec shadow qui suit la caméra
export function Lighting() {
  const lightRef = useRef<THREE.DirectionalLight>(null!);

  // La shadow camera suit la position de la caméra principale pour couvrir la zone visible
  useFrame(({ camera }) => {
    if (!lightRef.current) return;
    const cx = camera.position.x;
    lightRef.current.position.set(cx + 10, 20, 10);
    lightRef.current.target.position.set(cx, 0, 0);
    lightRef.current.target.updateMatrixWorld();
  });

  return (
    <>
      <ambientLight intensity={0.6} />
      <directionalLight
        ref={lightRef}
        position={[10, 20, 10]}
        intensity={1.2}
        castShadow
        shadow-mapSize-width={2048}
        shadow-mapSize-height={2048}
        shadow-camera-far={150}
        shadow-camera-left={-60}
        shadow-camera-right={60}
        shadow-camera-top={40}
        shadow-camera-bottom={-40}
        shadow-bias={-0.001}
      />
      <hemisphereLight args={["#87CEEB", "#556B2F", 0.4]} />
    </>
  );
}
